import { render, staticRenderFns } from "./modalVerImgUnica.vue?vue&type=template&id=71434b12&scoped=true"
import script from "./modalVerImgUnica.vue?vue&type=script&lang=js"
export * from "./modalVerImgUnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71434b12",
  null
  
)

export default component.exports